interface Window {
  Calistoga: {
    shopifyDomain: string;
    storefrontAccessToken: string;
  }
}

var client = ShopifyBuy.buildClient({
  domain: window.Calistoga.shopifyDomain,
  storefrontAccessToken: window.Calistoga.storefrontAccessToken,
});

var ui = ShopifyBuy.UI.init(client);

var productNodes = document.querySelectorAll('[data-shopify-id]');
productNodes.forEach((el : Element) => {
  if (el instanceof HTMLElement) {
    var productId = el.dataset.shopifyId;

    ui.createComponent('product', {
      id: productId,
      node: el,

      options: {
        product: {
          iframe: false,
          order: ['button'],
          contents: {
            img: false,
            title: false,
            variantTitle: false,
            price: true,
            options: false,
            quantity: false,
            quantityIncrement: false,
            quantityDecrement: false,
            quantityInput: false,
            button: true,
            description: false,
          },
          classes: {
            button: 'shopify-buy-btn'
          },
          templates: {
            button: `
              <button type="button" class="shopify-buy-btn group relative inline-flex px-6 py-1.5 text-center text-base font-sans uppercase tracking-widest transition-all duration-300 no-underline
                before:content-[''] before:absolute before:inset-0 before:[mask:var(--btn-mask)]
                text-black hover:text-copper-700 before:bg-copper-600
                hover:no-underline hover:before:bg-gradient-to-br hover:before:from-copper-400 hover:before:to-copper-600">
                <span class="transition-transform duration-200 group-hover:-translate-x-2">Add to Cart</span>
                <svg class="absolute right-2 top-1/2 w-4 h-4 opacity-0 transition-all duration-200 -translate-y-1/2 translate-x-2 group-hover:-translate-x-1 group-hover:opacity-100 text-copper-500">
                  <use fill="currentColor" xlink:href="/sprites/sprite.symbol.svg#arrow-right"></use>
                </svg>
              </button>
            `
          }
        },
        cart: {
          popup: false,
          styles: {
            button: {
              'background-color': '#b96e39',
              ':hover': {
                'background-color': '#7f3b13'
              }
            }
          }
        },
        toggle: {
          styles: {
            toggle: {
              'background-color': '#b96e39',
              ':hover': {
                'background-color': '#7f3b13'
              }
            }
          }
        }
      }
    });
  }
});
